export default __webpack_public_path__ + "static/media/MeasureYourPullRequests.f6591375.png";